import api from '@/api/sites';
import store from '@/store/store';

const fetchSites = (context, criteria) => {
  return new Promise(((resolve, reject) => {
    api.fetchSites(criteria.partnerId,criteria.pageIndex, criteria.searchTerm,criteria.orderInfo,criteria.isMobile)
      .then((response) => {
        resolve(response);
        if(!criteria.isMobile) {
          store.commit('sites/storeSiteList', response);
        }
      })
      .catch((error) => {
        // eslint-disable-next-line
        reject(error);
      });
  }));
};

const fetchSite = (context, criteria) => {
  return new Promise(((resolve, reject) => {
    api.fetchSite(criteria.partnerId,criteria.id)
      .then((response) => {
        resolve(response);
        store.commit('sites/storeSite', response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        reject(error);
      });
  }));
};

const updateSite = (context, criteria) => {
  return new Promise(((resolve, reject) => {
    api.updateSite(criteria.partnerId,criteria.params)
      .then((response) => {
        resolve(response);
        store.commit('sites/storeUpdatedSite', response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  }));
};

const createSite = (context, criteria) => {
  return new Promise(((resolve, reject) => {
    api.createSite(criteria.partnerId,criteria.params)
      .then((response) => {
        resolve(response);
        store.commit('sites/storeCreatedSite', response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  }));
};

const deleteSite = (context, criteria) => {
  return new Promise(((resolve, reject) => {
    api.deleteSite(criteria.partnerId,criteria.id)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  }));
};

export default {
  fetchSites,
  fetchSite,
  updateSite,
  createSite,
  deleteSite,
};




// WEBPACK FOOTER //
// ./src/store/modules/sites/actions.js